import { Chart } from "src/app/components";
import { useSiteStatChart } from "src/app/hooks";

const TrafficChartContainer = ({ moneySiteId }: { moneySiteId?: number }) => {
    const { siteStatsChart } = useSiteStatChart("TRAFFIC", moneySiteId);
    return (
        <Chart
            color="#2ECC71"
            yAxisFormatter={(value: number) =>
                value > 1000 ? `${value / 1000}k` : value.toString()
            }
            title="Traffic"
            data={siteStatsChart}
        />
    );
};

export default TrafficChartContainer;
